import { render, staticRenderFns } from "./SearchPois.vue?vue&type=template&id=a92a75e6&scoped=true&"
import script from "./SearchPois.vue?vue&type=script&lang=js&"
export * from "./SearchPois.vue?vue&type=script&lang=js&"
import style0 from "./SearchPois.vue?vue&type=style&index=0&id=a92a75e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92a75e6",
  null
  
)

export default component.exports